module.exports = __webpack_public_path__ + "static/html-element_7-03b507ebf155876944db2919ffe040de.jpg";